import React, { } from "react";
import classnames from "classnames";

import AlertModal from "components/AlertModal/AlertModal";

const typeIcons = {
  "pulse":"➿",
  "hold":"➰",
  "keep":"〰️",
}

const ActionButton = ({
  label,
  icon,
  classes,
  action,
  onConfirm,
  active = false,
  disabled = false,
  isMaintenanceButton = false,
}) => {
  const suffix = isMaintenanceButton ? `${action}?` : `${action} este carregamento?`;
  const confirmMessage = `Você tem certeza que deseja ${suffix}`;
  const maintenanceText = `
    <div style="font-size: 16px;"><b>ATENÇÃO</b></div>
    <div style="text-align: left; padding-top: 10px; padding-left: 30px; font-size: 14px;">Tipos de comando:</div>
    <div style="text-align: left; padding-top: 5px; padding-left: 10px; margin: auto; font-size: 14px;"><b>〰️ Contínuo</b> - Ao clicar ficará acionado até clicar novamente</div>
    <div style="text-align: left; padding-top: 1px; padding-left: 10px; margin: auto; font-size: 14px;"><b>➿ Pulsado</b> - Ao clicar o comando irá pulsar até clicar novamente</div>
    <div style="text-align: left; padding-top: 1px; padding-left: 10px; margin: auto; font-size: 14px;"><b>➰ Segurar</b> - Necessita manter clicado para acionar</div>
    <div style="padding-top: 10px; margin: auto; font-size: 14px;"><b>${confirmMessage}</b></div>
  `;
  const modalTitle = isMaintenanceButton ? null : confirmMessage;
  const modalText = isMaintenanceButton ? maintenanceText : null;
  const handleClick = () => {
    if (!disabled) {
      AlertModal.fire({
        title: modalTitle,
        html: modalText,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1D84C6",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Voltar",
        reverseButtons: true,
      })
        .then(result => {
          if (result.value) {
            onConfirm();
          }
        });
    }
  };

  const buttonClasses = classnames("action-button", classes, {
    active,
    disabled,
  });

  return (
    <div className={buttonClasses} onClick={handleClick}>
      <img src={icon} alt="img" />

      <span>{label}</span>
    </div>
  );
};

export default ActionButton;
